import { useEffect, useRef } from 'react';
import { getHowlerSFX } from 'js/components/audio/howler';
import { useSelector } from 'react-redux';

export function useSFX() {
  const howlerSFX = useRef({});
  const audioIsActive = useSelector((state) => {
    return true;
  });
  const playSFX = (key, vol = 0.5) => {
    const context = howlerSFX?.current?.play || false;
    if (audioIsActive && key && context) {
      const id = howlerSFX?.current?.play(key);
      howlerSFX.current.volume(vol, id);
    }
  };
  useEffect(() => {
    howlerSFX.current = getHowlerSFX();
    return () => {};
  }, []);

  return { playSFX };
}
